import { createContext, useContext } from "react";

export const HeaderContext = createContext({
  isNewHeader: false,
});

export function useIsNewHeader() {
  return useContext(HeaderContext).isNewHeader;
}
